import { Fragment, useState } from "react";
import moment from "moment/moment";
import { Dialog, Transition } from "@headlessui/react";

import config from "config/config";
import { sendPaymetToOrbitalApi } from "service/paymentServices/sendPaymetToOrbitalApi";

import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import DialogBackdrop from "components/ModalDialogs/DialogBackdrop";
import { useTranslation, Trans } from "react-i18next";

const AuthedCustomerAuthorizePaymentModal = ({
  modalState,
  setModalState,
  setConfirmationModal,
  uid,
  selectedCard,
  amount,
  policyNumber,
  useCustomerRefNum,
  setTxRefNum,
  setProcStatus,
  setUserValErrorModalState,
  setErrorTitle,
  setErrorDisc,
  isRequierd,
  setIsRequierd,
  policies,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  async function submit() {
    //exsting card using
    // Get Profile and call to Orbetal api
    setIsLoading(true);
    let policy = policies?.find((p) => p.contractID === policyNumber);
    await sendPaymetToOrbitalApi(
      amount,
      policyNumber,
      useCustomerRefNum,
      policy?.blockCode
    )
      .then((response) => {
        if (response?.order?.txRefNum) {
          setIsLoading(false);
          setProcStatus(response?.procStatus);
          setTxRefNum(response?.order?.txRefNum);
          setConfirmationModal(true);
          setModalState(false);
        } else {
          setIsLoading(false);
          setErrorDisc(
            t("CustomerAuthedCustomerAuthorizePaymentModal-SetErrorDisc")
          );
          setErrorTitle(t("CustomerAuthedCustomerAuthorizePaymentModal-Error"));
          setUserValErrorModalState(true);
          setModalState(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setErrorDisc(
          t("CustomerAuthedCustomerAuthorizePaymentModal-SetErrorDisc")
        );
        setErrorTitle(t("CustomerAuthedCustomerAuthorizePaymentModal-Error"));
        setUserValErrorModalState(true);
        setModalState(false);
        console.error(error);
      });
  }
  return (
    <Transition appear show={modalState} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-50 overflow-y-auto"
        open={modalState}
        onClose={() => {
          setModalState(false);
        }}
      >
        <DialogBackdrop />
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-5xl p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <Dialog.Title
                as="h2"
                className="dialog_label2 font-body text-xl font-bold text-left"
              >
                {t(
                  "CustomerAuthedCustomerAuthorizePaymentModal-AuthorizePayment"
                )}
                <button
                  className="ui-default-dialog-close"
                  onClick={() => setModalState(false)}
                >
                  <svg
                    className="ui-icon h-3.5 w-3.5"
                    focusable="false"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <use href="#ui-icon-close"></use>
                  </svg>
                </button>
              </Dialog.Title>
              <hr />
              <EverlakeLoadingOverlay isLoading={isLoading} loadingText="">
                <form
                  method="GET"
                  action={`${config.HOSTED_PAYMENT_SERVICE_BASE_URL}`}
                >
                  <input type="hidden" name="uid" value={`${uid}`} />
                  <div className="mx-auto lg:w-4/5">
                    {config.ENABLE_ADD_CREDIT_CARD_UPDATE === "true" ? (
                      selectedCard === "newcard" ? (
                        <>
                          <p id="ID_dialogAuthorizePaymentDesc">
                            {t(
                              "CustomerAuthedCustomerAuthorizePaymentModal-dialogAuthorizePayment-Desc01"
                            )}
                          </p>
                          <div className="mt-6">
                            <label className="ui-checkbox">
                              <input
                                type="checkbox"
                                required
                                onClick={() => setIsRequierd(false)}
                              />
                              <div className="ui-checkmark">
                                <svg
                                  className="ui-icon w-2 h-2 text-white"
                                  focusable="false"
                                  aria-hidden="true"
                                  role="presentation"
                                >
                                  <use href="#ui-icon-checkmark"></use>
                                </svg>
                              </div>
                              <span>
                                {t(
                                  "CustomerAuthedCustomerAuthorizePaymentModal-PaymentRequestDate"
                                )}{" "}
                                {moment().format("MM/DD/YYYY")}.
                              </span>
                            </label>
                          </div>
                        </>
                      ) : (
                        <>
                          <p id="ID_dialogAuthorizePaymentDesc">
                            {t(
                              "CustomerAuthedCustomerAuthorizePaymentModal-DialogAuthorizePaymentDesc01"
                            )}{" "}
                            <strong> {selectedCard} </strong>{" "}
                            {t(
                              "CustomerAuthedCustomerAuthorizePaymentModal-DialogAuthorizePaymentDesc02"
                            )}
                          </p>
                          <div className="mt-6">
                            <label className="ui-checkbox">
                              <input
                                type="checkbox"
                                required
                                onClick={() => setIsRequierd(false)}
                              />
                              <div className="ui-checkmark">
                                <svg
                                  className="ui-icon w-2 h-2 text-white"
                                  focusable="false"
                                  aria-hidden="true"
                                  role="presentation"
                                >
                                  <use href="#ui-icon-checkmark"></use>
                                </svg>
                              </div>
                              <span>
                                {t(
                                  "AuthedCustomerAuthorizePaymentModal-PaymentRequestDate"
                                )}{" "}
                                {moment().format("MM/DD/YYYY")}.
                              </span>
                            </label>
                          </div>
                        </>
                      )
                    ) : (
                      <>
                        <p id="ID_dialogAuthorizePaymentDesc">
                          {t(
                            "CustomerAuthedCustomerAuthorizePaymentModal-AuthorizePaymentDesc04"
                          )}{" "}
                          through
                          {selectedCard === "newcard" ? (
                            t(
                              "CustomerAuthedCustomerAuthorizePaymentModal-AuthorizePaymentDesc03"
                            )
                          ) : (
                            <>
                              {" "}
                              {t(
                                "CustomerAuthedCustomerAuthorizePaymentModal-AuthorizePaymentDesc02"
                              )}
                              <strong> {selectedCard} </strong>
                            </>
                          )}
                          {t(
                            "CustomerAuthedCustomerAuthorizePaymentModal-AuthorizePaymentDesc01"
                          )}
                        </p>
                        <div className="mt-6">
                          <label className="ui-checkbox">
                            <input
                              type="checkbox"
                              required
                              onClick={() => setIsRequierd(false)}
                            />
                            <div className="ui-checkmark">
                              <svg
                                className="ui-icon w-2 h-2 text-white"
                                focusable="false"
                                aria-hidden="true"
                                role="presentation"
                              >
                                <use href="#ui-icon-checkmark"></use>
                              </svg>
                            </div>
                            <span>
                              {t(
                                "CustomerAuthedCustomerAuthorizePaymentModal-PaymentRequestDate"
                              )}{" "}
                              {moment().format("MM/DD/YYYY")}.
                            </span>
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="block text-right mt-6">
                    <button
                      type="button"
                      className="ui-btn-secondary min-w-[140px] mt-4"
                      aria-label="Cancel authorizing this payment"
                      onClick={() => setModalState(false)}
                    >
                      {t("CustomerAuthedCustomerAuthorizePaymentModal-Cancel")}
                    </button>
                    {selectedCard === "newcard" && (
                      <>
                        <button
                          id="ID_submitAuthorizePayment"
                          className="ui-btn-primary min-w-[140px] mt-4"
                          aria-label="authorize this payment"
                        >
                          {t(
                            "CustomerAuthedCustomerAuthorizePaymentModal-Submit"
                          )}
                        </button>
                      </>
                    )}
                    {selectedCard !== "newcard" && (
                      <button
                        type="button"
                        id="ID_submitAuthorizePayment"
                        className="ui-btn-primary min-w-[140px] mt-4"
                        aria-label="authorize this payment"
                        onClick={() => submit()}
                        disabled={isRequierd}
                      >
                        {t(
                          "CustomerAuthedCustomerAuthorizePaymentModal-Submit"
                        )}
                      </button>
                    )}
                  </div>
                </form>
              </EverlakeLoadingOverlay>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AuthedCustomerAuthorizePaymentModal;
